/* ============================================================================
   nuud US — theme-wide behaviour
   ----------------------------------------------------------------------------
   Deliberately small. Section behaviour lives in that section's own asset
   (buy-box.js, sticky-bar.js, social-proof.js) so a developer can find it by
   the name of the thing that is misbehaving.
   ========================================================================= */
(function () {
  'use strict';

  /* --------------------------------------------------------- nav dropdown
     The dropdown opens on hover and on :focus-within with no JS at all, which
     covers a pointer and the keyboard. This adds the two things CSS cannot do:
     a real click/tap toggle that latches open, and `aria-expanded`, which a
     screen reader needs and a :hover rule cannot express.

     Everything here is additive. With JS off, the CSS still opens the menu. */
  document.querySelectorAll('.header__item--has-menu').forEach(function (item) {
    var toggle = item.querySelector('.header__toggle');
    if (!toggle) return;

    toggle.setAttribute('aria-expanded', 'false');

    function setOpen(open) {
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!item.classList.contains('is-open'));
    });

    /* A click anywhere else closes it. */
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) setOpen(false);
    });

    /* Escape closes it and puts the caret back on the control that opened it,
       so keyboard focus is never left inside a panel that is no longer there. */
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
  });

  /* ------------------------------------------------------- signup feedback
     The footer signup is a real form POST. Shopify redirects back to the top
     of the page, which leaves its own answer -- "Thanks. You are on the list."
     or the error -- sitting in the footer, off screen. To the person who just
     clicked Sign up, that is indistinguishable from a button that does
     nothing. Put the answer where they are looking.
     Wait for `load`, not DOMContentLoaded: a scroll issued while the document
     is still parsing is undone by the browser's own scroll restoration, and
     the page snaps back to the top. */
  var signupMsg = document.querySelector('[data-signup-msg]');
  if (signupMsg) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        // Instant, not smooth. The footer can be 6000px down; animating the
        // whole way is a long ride to a one-line confirmation, and a smooth
        // scroll is throttled to nothing in a backgrounded tab.
        signupMsg.scrollIntoView({ block: 'center' });
        signupMsg.focus({ preventScroll: true });
      }, 0);
    });
  }

  /* ------------------------------------------------------ discount waiting
     Shopify applies a discount code to the CART, not to the prices on the
     page, and `/discount/CODE` strips itself from the URL on the way in. So a
     visitor who clicked a "10% off" email lands on list prices with nothing to
     say the code took, and reasonably concludes it did not.

     `cart.discount_codes` survives an EMPTY cart, which is what makes this
     possible before anything is added. Once there is something in the cart the
     saving is a real number, so say the number. */
  var discountNote = document.querySelector('[data-discount-note]');
  if (discountNote) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        if (!codes.length) return;

        if (cart.total_discount > 0) {
          var saved = (cart.total_discount / 100).toFixed(2);
          discountNote.textContent = 'Your discount is on. You save $' + saved + ' at checkout.';
        } else {
          discountNote.textContent = 'Your discount is saved. It comes off at checkout.';
        }
        discountNote.setAttribute('data-code-note', '');
        discountNote.hidden = false;
      })
      .catch(function () { /* no note is better than a wrong one */ });
  }

  /* Keep the header cart count in step after an AJAX add, if anything on the
     page dispatches `cart:updated` with a count. */
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  });
})();
